import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Attachment } from 'go-modules/services/attachment/attachment';
import { mediaToken } from 'go-modules/models/media/media.factory';

type NewAttachment = Pick<Attachment, 'resource_type' | 'resource_id' | 'media' | 'media_id'>;

@Injectable({
	providedIn: 'root'
})
export class AttachmentService {
	public static RESOURCE_TYPE = 'attachment';
	private readonly basePath = `${clientSettings.GoReactV2API}/attachments`;

	constructor (
		private http: HttpClient,
		@Inject(mediaToken) private MediaModel
	) {}

	public getSessionAttachments (sessionId: number): Observable<Attachment[]> {
		return this.http.get<Attachment[]>(`${this.basePath}/session/${sessionId}`)
			.pipe(
				map((response) => this.transformResponse(response))
			);
	}

	public save (attachment: Attachment | NewAttachment): Observable<Attachment> {
		if ('id' in attachment && attachment.id) {
			return this.http.put<Attachment>(`${this.basePath}/${attachment.id}`, attachment)
				.pipe(map((response) => this.transformSingleResponse(response)));
		} else {
			return this.http.post<Attachment>(this.basePath, attachment)
				.pipe(map((response) => this.transformSingleResponse(response)));
		}
	}

	public delete (attachmentId: number): Observable<void> {
		return this.http.delete<void>(`${this.basePath}/${attachmentId}`);
	}

	public transformResponse (response: Attachment[] | Attachment): Attachment[] {
		if (Array.isArray(response)) {
			return response.map((item) => this.transformSingleResponse(item));
		} else {
			return [this.transformSingleResponse(response)];
		}
	}

	private transformSingleResponse (data: Attachment): Attachment {
		if (data.hasOwnProperty('media')) {
			data.media = this.MediaModel.model(data.media);
		}
		return data;
	}
}
